module.exports = flarum.reg.get('core', 'common/helpers/textContrastClass');